<template>
  <nav class="Nav">
      <inertia-link
          v-for="(item, index) in $page.props.main_navigation"
          :key="item.route"
          class="Nav__link"
          :class="item.route == route().current() ? 'is--active' : '' "
          :href="$officeRoute(item.route)"
      >
        <div class="inner">
          <div v-if="index === 0" class="Icon__container">
            <Icon :name="item.icon" />
          </div>
          <span v-if="item.title != ''">
            {{ item.prefix }}
            <strong>{{ item.title }}</strong>
          </span>
        </div>
      </inertia-link>
    <div class="Nav__line" ref="NavLine"></div>
  </nav>
</template>

<script>

import _ from 'lodash'
import { Inertia } from '@inertiajs/inertia'
import {gsap} from 'gsap'
import Icon from '@components/Icon'

export default {
  components: {
    Icon,
  },
  data() {
    return {
      navEls: null,
      current: null
    }
  },
  mounted() {

    this.navEls = this.$el.querySelectorAll('.Nav__link')
    this.current = this.$el.querySelector('.is--active')
    this.$nextTick(this.firstEntrance())
    this.updateCurrentInertia = Inertia.on('finish', this.updateCurrent)

  },
  unmounted() {
    window.removeEventListener('resize', this.onWindowResize)
    this.updateCurrentInertia()
  },
  methods: {
    setCurrentActive(withTransition = true) {
      this.current = this.$el.querySelector('.is--active')
      if (this.current) this.animeActive(withTransition)
      else this.disableLine(withTransition)
    },
    firstEntrance() {

      window.addEventListener('popstate', (event) => {
        this.updateCurrent()
      });

      const {current} = this
      const {NavLine} = this.$refs

      if (current == undefined) return

      if (window.innerWidth < 768) {
        gsap.from(NavLine, {
          xPercent: -100, duration: 0.6, ease: "expo.out", delay: 0.4, onStart: () => {
            gsap.set(NavLine, {y: current.offsetTop, x: 0, height: current.offsetHeight, scaleY: 1})
          }
        })
      } else {
        gsap.from(NavLine, {
          yPercent: 100, duration: 0.6, ease: "expo.out", delay: 0.4, onStart: () => {
            gsap.set(NavLine, {x: current.offsetLeft, y: 0, width: current.offsetWidth, scaleY: 1})
          }
        })
      }

      window.addEventListener('resize', this.onWindowResize)
    },
    animeActive(transition = true) {
      const {current} = this
      const {NavLine} = this.$refs

      if (window.innerWidth < 768) {
        transition ? gsap.to(NavLine, {
              x: 0,
              y: current.offsetTop,
              height: current.offsetHeight,
              xPercent: 0,
              duration: 0.6,
              ease: "expo.out",
            })
            : gsap.set(NavLine, {y: current.offsetTop, x: 0, height: current.offsetHeight, scaleY: 1})
      } else {
        transition ? gsap.to(NavLine, {
              x: current.offsetLeft,
              y: 0,
              width: current.offsetWidth,
              yPercent: 0,
              duration: 0.6,
              ease: "expo.out"
            })
            : gsap.set(NavLine, {x: current.offsetLeft, y: 0, width: current.offsetWidth, scaleY: 1})
      }
    },
    disableLine(transition = true) {
      const {NavLine} = this.$refs

      if (window.innerWidth < 768) {
        transition ? gsap.to(NavLine, {xPercent: -100, yPercent: 0, duration: 0.6, ease: "expo.out"})
            : gsap.set(NavLine, {xPercent: -100, yPercent: 0})
      } else {
        transition ? gsap.to(NavLine, {yPercent: 100, xPercent: 0, duration: 0.6, ease: "expo.out"})
            : gsap.set(NavLine, {yPercent: 100, xPercent: 0})
      }
    },
    updateCurrent() {
      if (this.$page.props.main_navigation){
        this.$page.props.main_navigation.forEach(item => item.current = item.route == route().current())
        this.$nextTick(this.setCurrentActive)
      }
    },
    onWindowResize: _.debounce(function () {
      this.setCurrentActive(true)
    }, 100)
  }
}
</script>

<style lang="scss">
@import "~@sass/components/Nav";
</style>
